import { SimpleButtonStyle } from '../components/training/Types';

export const toAgilityButtonStyle = (style: SimpleButtonStyle) => ({
  contentID: 0,
  properties: {
    state: 1,
    modified: '',
    versionID: 1,
    referenceName: '',
    definitionName: '',
    itemOrder: 0,
  },
  fields: { ...style },
});
